import React, { AllHTMLAttributes, ReactChild } from "react";
import { Portal } from "../../portal";
import { VisuallyHidden } from "../../visuallyhidden";

export interface LiveRegionProps extends AllHTMLAttributes<HTMLDivElement> {
    children: ReactChild;

    /**
     * A `clientId` prop is provided for specified elements, which is a
     * unique string that appears as a data attribute `data-client-id` in
     * the rendered code, serving as a hook for automated tests.
     */
    clientId?: string;
}

export const LiveRegion = ({ children, ...rest }: LiveRegionProps) => {
    return (
        <Portal zIndex={-1}>
            <VisuallyHidden aria-live="polite" {...rest}>
                {children}
            </VisuallyHidden>
        </Portal>
    );
};
